import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import { PersonOutline, LockOutlined, Login } from "@mui/icons-material";
import { message } from "antd";
import { useTranslation } from "react-i18next";

const MyLoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { t } = useTranslation();

  const handleLogin = () => {
    // Basic validation
    if (!username || !password) {
      message.error("Please enter both username and password.");
      return;
    }

    const URI = "https://api.clever-school.com/api/login";
    const requestBody = {
      username,
      password,
    };

    fetch(URI, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        const userRole = data?.user?.role?.toLowerCase();
        const allowedRoles = new Set(["superadmin", "admin", "dataentry"]);

        if (allowedRoles.has(userRole)) {
          message.success(`Login successful as ${userRole}`);

          // Store authentication data
          localStorage.setItem("token", data.token);
          // localStorage.setItem("userRole", userRole);
          localStorage.setItem("user", JSON.stringify(data.user));

          // Role-based redirection
          // eslint-disable-next-line no-unused-vars
          const roleRoutes = {
            superadmin: "/",
            admin: "/",
            dataentry: "/",
          };

          window.location.href = "/";
        } else {
          message.error("Insufficient privileges for system access");
          localStorage.clear();
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        message.error("Invalid credentials or network error");
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg,rgb(238, 242, 245) 0%,rgb(196, 206, 218) 100%)",
        padding: 3,
      }}
    >
      <Container maxWidth="xs">
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            borderRadius: 4,
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "translateY(-5px)",
            },
          }}
        >
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "black",
                mb: 1,
                textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              {t("Login to continue")}
            </Typography>
          </Box>

          <TextField
            fullWidth
            label={t("username")}
            variant="outlined"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            InputProps={{
              startAdornment: (
                <PersonOutline sx={{ color: "#3766ac", mr: 1, fontSize: 24 }} />
              ),
              sx: {
                borderRadius: 3,
                "&:hover fieldset": { borderColor: "#3766ac!important" },
                "&.Mui-focused fieldset": { borderColor: "#3766ac!important" },
              },
            }}
          />

          <TextField
            fullWidth
            label={t("password")}
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <LockOutlined sx={{ color: "#3766ac", mr: 1, fontSize: 24 }} />
              ),
              sx: {
                borderRadius: 3,
                "&:hover fieldset": { borderColor: "#3766ac!important" },
                "&.Mui-focused fieldset": { borderColor: "#3766ac!important" },
              },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleLogin}
            sx={{
              mt: 3,
              mb: 2,
              py: 1.5,
              borderRadius: 3,
              background: "linear-gradient(45deg,#3766ac 30%,#1b355e 90%)",
              fontWeight: 700,
              letterSpacing: 1.1,
              "&:hover": {
                boxShadow: "0 4px 12px rgba(46, 62, 125, 0.4)",
                transform: "translateY(-2px)",
              },
              transition: "all 0.3s ease",
            }}
            startIcon={<Login sx={{ fontSize: 28 }} />}
          >
            {t("login")}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default MyLoginPage;
